const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.VaccinationServiceSimpleClient =
  function VaccinationServiceSimpleClient(hostname, credentials, options) {
    if (!options) options = {};
    options["format"] = "text";

    this.client_ = new grpc.web.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;

    this.listVaccinations = this.listVaccinations.bind(this);
    this.getVaccination = this.getVaccination.bind(this);
    this.deleteVaccination = this.deleteVaccination.bind(this);
    this.listVaccinationComments = this.listVaccinationComments.bind(this);
    this.createVaccinationComment = this.createVaccinationComment.bind(this);
    this.deleteVaccinationComment = this.deleteVaccinationComment.bind(this);
    this.updateVaccinationComment = this.updateVaccinationComment.bind(this);
    this.addVaccineInjection = this.addVaccineInjection.bind(this);
    this.addBoosterInjection = this.addBoosterInjection.bind(this);
    this.listInjections = this.listInjections.bind(this);
    this.deleteInjection = this.deleteInjection.bind(this);
    this.updateInjection = this.updateInjection.bind(this);
    this.listMedicines = this.listMedicines.bind(this);
  };
const methodInfo_VaccinationService_ListVaccinations =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/ListVaccinations",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListVaccinationsRequest,
    imports.stronachgroup.first.racehorse360.ListVaccinationsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListVaccinationsResponse.decode
  );
module.exports.VaccinationServiceSimpleClient.prototype.listVaccinations =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListVaccinationsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/ListVaccinations",
      message,
      metadata || {},
      methodInfo_VaccinationService_ListVaccinations
    );
  };
const methodInfo_VaccinationService_GetVaccination =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/GetVaccination",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.GetVaccinationRequest,
    imports.stronachgroup.first.racehorse360.Vaccination,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Vaccination.decode
  );
module.exports.VaccinationServiceSimpleClient.prototype.getVaccination =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.GetVaccinationRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/GetVaccination",
      message,
      metadata || {},
      methodInfo_VaccinationService_GetVaccination
    );
  };
const methodInfo_VaccinationService_DeleteVaccination =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/DeleteVaccination",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.DeleteVaccinationRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.VaccinationServiceSimpleClient.prototype.deleteVaccination =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.DeleteVaccinationRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/DeleteVaccination",
      message,
      metadata || {},
      methodInfo_VaccinationService_DeleteVaccination
    );
  };
const methodInfo_VaccinationService_ListVaccinationComments =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/ListVaccinationComments",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListVaccinationCommentsRequest,
    imports.stronachgroup.first.racehorse360.ListVaccinationCommentsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListVaccinationCommentsResponse.decode
  );
module.exports.VaccinationServiceSimpleClient.prototype.listVaccinationComments =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListVaccinationCommentsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/ListVaccinationComments",
      message,
      metadata || {},
      methodInfo_VaccinationService_ListVaccinationComments
    );
  };
const methodInfo_VaccinationService_CreateVaccinationComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/CreateVaccinationComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.CreateVaccinationCommentRequest,
    imports.stronachgroup.first.racehorse360.VaccinationComment,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.VaccinationComment.decode
  );
module.exports.VaccinationServiceSimpleClient.prototype.createVaccinationComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.CreateVaccinationCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/CreateVaccinationComment",
      message,
      metadata || {},
      methodInfo_VaccinationService_CreateVaccinationComment
    );
  };
const methodInfo_VaccinationService_DeleteVaccinationComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/DeleteVaccinationComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.VaccinationServiceSimpleClient.prototype.deleteVaccinationComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.DeleteVaccinationCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/DeleteVaccinationComment",
      message,
      metadata || {},
      methodInfo_VaccinationService_DeleteVaccinationComment
    );
  };
const methodInfo_VaccinationService_UpdateVaccinationComment =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/UpdateVaccinationComment",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest,
    imports.stronachgroup.first.racehorse360.VaccinationComment,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.VaccinationComment.decode
  );
module.exports.VaccinationServiceSimpleClient.prototype.updateVaccinationComment =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.UpdateVaccinationCommentRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/UpdateVaccinationComment",
      message,
      metadata || {},
      methodInfo_VaccinationService_UpdateVaccinationComment
    );
  };
const methodInfo_VaccinationService_AddVaccineInjection =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/AddVaccineInjection",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.AddVaccineInjectionRequest,
    imports.stronachgroup.first.racehorse360.Injection,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Injection.decode
  );
module.exports.VaccinationServiceSimpleClient.prototype.addVaccineInjection =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.AddVaccineInjectionRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/AddVaccineInjection",
      message,
      metadata || {},
      methodInfo_VaccinationService_AddVaccineInjection
    );
  };
const methodInfo_VaccinationService_AddBoosterInjection =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/AddBoosterInjection",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.AddBoosterInjectionRequest,
    imports.stronachgroup.first.racehorse360.Injection,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Injection.decode
  );
module.exports.VaccinationServiceSimpleClient.prototype.addBoosterInjection =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.AddBoosterInjectionRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/AddBoosterInjection",
      message,
      metadata || {},
      methodInfo_VaccinationService_AddBoosterInjection
    );
  };
const methodInfo_VaccinationService_ListInjections =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/ListInjections",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListInjectionsRequest,
    imports.stronachgroup.first.racehorse360.ListInjectionsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListInjectionsResponse.decode
  );
module.exports.VaccinationServiceSimpleClient.prototype.listInjections =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListInjectionsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/ListInjections",
      message,
      metadata || {},
      methodInfo_VaccinationService_ListInjections
    );
  };
const methodInfo_VaccinationService_DeleteInjection =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/DeleteInjection",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.DeleteInjectionRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.VaccinationServiceSimpleClient.prototype.deleteInjection =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.DeleteInjectionRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/DeleteInjection",
      message,
      metadata || {},
      methodInfo_VaccinationService_DeleteInjection
    );
  };
const methodInfo_VaccinationService_UpdateInjection =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/UpdateInjection",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.UpdateInjectionRequest,
    imports.stronachgroup.first.racehorse360.Injection,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.Injection.decode
  );
module.exports.VaccinationServiceSimpleClient.prototype.updateInjection =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.UpdateInjectionRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/UpdateInjection",
      message,
      metadata || {},
      methodInfo_VaccinationService_UpdateInjection
    );
  };
const methodInfo_VaccinationService_ListMedicines =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.VaccinationService/ListMedicines",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.ListMedicinesRequest,
    imports.stronachgroup.first.racehorse360.ListMedicinesResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.ListMedicinesResponse.decode
  );
module.exports.VaccinationServiceSimpleClient.prototype.listMedicines =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.ListMedicinesRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.VaccinationService/ListMedicines",
      message,
      metadata || {},
      methodInfo_VaccinationService_ListMedicines
    );
  };
